import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

export const useAlert = () => {
  const alertClosed = {
    open: false,
    message: 'Unknown error',
    severity: 'error',
  };
  const [alert, setAlert] = React.useState(alertClosed);
  const setAlertWithTimeout = (state) => {
    setAlert(state);
    const timeout = setTimeout(() => {
      setAlert(alertClosed);
      clearTimeout(timeout);
    }, 3000);
  };
  return [alert, setAlertWithTimeout];
};

export default function PopUpAlert({ alert, setAlert }) {
  return (
    <Box sx={{ width: '30%', position: 'fixed', bottom: 0, right: 15 }}>
      <Collapse in={alert.open}>
        <Alert
          severity={alert.severity}
          // variant='filled'
          action={
            <IconButton
              aria-label='close'
              size='small'
              onClick={() => {
                setAlert({ ...alert, open: false });
              }}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alert.message}
        </Alert>
      </Collapse>
    </Box>
  );
}
